import { GroupMembers } from '../../../../../../ui/features/groups/components/GroupsPanel/components/GroupMembers';
import { useGroup } from '../../../../../../ui/features/groups/hooks/useGroup';
import { useContactManagementTranslation } from '../../../../../../ui/hooks';
import { PageError } from '@juvare/common-web-ui/PageError';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, CircularProgress, DialogContent, IconButton, Toolbar, Typography } from '@mui/material';
import React from 'react';
export const EditGroupMembersContent = ({ groupId, close, customMemberDetailsComponent }) => {
    const { t } = useContactManagementTranslation();
    const groupResponse = useGroup(groupId);
    const group = groupResponse.data;
    const isLoading = groupResponse.isLoading;
    const error = groupResponse.error;
    const handleReloadGroup = groupResponse.mutate;
    const handleCloseEditGroupFilter = () => {
        close();
        handleReloadGroup();
    };
    if (group) {
        return (React.createElement(React.Fragment, null,
            React.createElement(AppBar, { sx: { position: 'relative' }, "data-test": 'app-bar' },
                React.createElement(Toolbar, null,
                    React.createElement(IconButton, { edge: 'start', color: 'inherit', onClick: handleCloseEditGroupFilter, "data-test": 'close-button', "aria-label": t('common.close') },
                        React.createElement(CloseIcon, null)),
                    React.createElement(Typography, { variant: 'h6', sx: { flexGrow: 1 } }, t('panels.groups.editGroupFilter')))),
            React.createElement(DialogContent, { sx: { height: '100%' } },
                React.createElement(GroupMembers, { group: group, useDataTableState: true, onReloadGroup: handleReloadGroup, customMemberDetailsComponent: customMemberDetailsComponent }))));
    }
    else if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    else {
        return React.createElement(PageError, { error: error });
    }
};
